import React from 'react';
import { toColor } from './utils';

const ColorBox = (props: any) => {
  const style = {
    display: 'inline-block',
    width: '8px',
    height: '8px',
    backgroundColor: toColor(props.color),
    borderRadius: '0.5em',
  };
  return <div className={props.className} style={style} />;
};

export default ColorBox;
